import { useHomeUsePluginContainer } from "@custom-hooks/HomeUsePluginRoot";
import { imagicaAppfonts, localFontFaceList } from "./Const";
import styles from "./FontStyle.module.scss";
import { useSignal } from "@preact/signals-react";
import { useCallback, useEffect } from "react";
import { PreviewPaneBloc } from "../../PreviewPaneBloc";
import { FontType } from "imagica-corekit/dist/cases/theme/fontTheme/FontData";
import { PowerMaskView } from "@uiview/views/PowerMask/PowerMaskView";
import func from "@uikit/func";
import { getIt } from "@uikit/getIt";
import { WebConfigStore } from "imagica-corekit/dist/cases/webconfig/WebConfigStore";
import { useStore } from "imagica-uikit/dist/hooks/useStore";
import { PowerMaskUitl } from "@uiview/views/PowerMask/PowerMaskUtil";
import { Popover } from "antd";

export function FontStyle(props: { bloc: PreviewPaneBloc }) {
  const {
    saasAndThinkState: { saasUIData },
  } = useHomeUsePluginContainer();
  const webConfigState = useStore(getIt(WebConfigStore)).value;

  const currentSelectFont = useSignal(FontType.AKREGULAR);
  const fontList = webConfigState.imagicaAppfonts;

  const clickFont = async (feature: string[], str: FontType) => {
    if (await PowerMaskUitl.disAbleByFeature(feature)) {
      return;
    }
    props.bloc.changeFont(str);
    currentSelectFont.value = str;
  };
  const handleFontFace = useCallback(() => {
    // 创建一个新的style元素
    var style = document.createElement("style");
    style.type = "text/css";
    fontList.forEach(x => {
      if (!func.isEmpty(x.fontFaceUrl) && !localFontFaceList.includes(x.fontFaceUrl)) {
        const fontFace = `
          @font-face {
            font-family: ${x.fontFamily};
            src: url(${x.fontFaceUrl})
          }
        `;
        style.appendChild(document.createTextNode(fontFace));
        document.head.appendChild(style);
      }
    });
  }, [fontList]);
  useEffect(() => {
    handleFontFace();
  }, [fontList]);

  useEffect(() => {
    if (saasUIData?.settings?.fontFamily) {
      const preFontFamily = saasUIData.settings.fontFamily as unknown as FontType;
      currentSelectFont.value = preFontFamily === FontType.AKTIVGROTESK ? FontType.AKREGULAR : preFontFamily;
    } else {
      currentSelectFont.value = FontType.AKREGULAR;
    }
  }, [saasUIData?.settings?.fontFamily]);
  return (
    <div className={styles.FontStyle}>
      <div className={styles.title}>Font style</div>
      <div className={styles.fontBox}>
        {fontList.map((item: any, index: number) => {
          return (
            <div
              className={`${styles.item_div} ${currentSelectFont.value === item.fontFamily ? styles.activeFont : ""}`}
              key={index}
            >
              <PowerMaskView feature={item.features}>
                <Popover
                  content={item.fontFamily === "Ak-Regular" ? "AkRegular" : item.fontFamily}
                  placement="top"
                  trigger="hover"
                  getPopupContainer={e => e}
                >
                  <div
                    key={index}
                    style={{ fontFamily: item.fontFamily }}
                    onClick={() => clickFont(item.features, item.fontFamily)}
                  >
                    Aa
                  </div>
                </Popover>
              </PowerMaskView>
            </div>
          );
        })}
      </div>
    </div>
  );
}
